/* eslint-disable no-unused-vars */
import React, {
  useContext, useEffect, useMemo,
} from 'react';
import classNames from 'classnames';
import {
  Nav, Navbar,
} from 'react-bootstrap';
import AppContext from '../../context/Context';
import Flex from '../../common/Flex';
import Logo from '../../common/Logo';
import NavbarTopDropDownMenus from '../top/NavbarTopDropDownMenus';
import bgNavbar from '../../../../assets/img/generic/bg-navbar.png';
import ToggleButton from './ToggleButton';
import NavbarVerticalMenu from './NavbarVerticalMenu';
import { navbarBreakPoint, topNavbarBreakpoint } from '../../config';
import { CiatAppContext } from '../../../../providers';

function NavbarVertical() {
  const {
    config: {
      navbarPosition,
      navbarStyle,
      isNavbarVerticalCollapsed,
      showBurgerMenu,
    },
  } = useContext(AppContext);

  const HTMLClassList = document.getElementsByTagName('html')[0].classList;

  const { currentUser } = useContext(CiatAppContext);

  // const [isCollapsed, setIsCollapsed] = useState(isNavbarVerticalCollapsed);

  const sections = useMemo(
    () => [
      ...currentUser.available_sections,
      {
        label: 'Звітність',
        name: 'reports',
        children: [
          {
            name: 'reports-panel',
            frontendURL: '/rep/',
            label: 'Зведений перелік звітів',
          },
        ],
      },
    ].map((el) => {
      switch (el.name) {
        case 'logica':
          return el;
        case 'fbr':
          el.children.push(
            {
              name: 'reports',
              label: 'Звіти',
              children: [
                {
                  name: 'reports-panel',
                  filter: 'schema_obligations_report',
                  frontendURL: '/rep/schema_obligations_report/',
                  label: "Звіти по зобов'язанням",
                },
              ],
            },
          );
          return el;
        default:
          return el;
      }
    }),
    [currentUser.available_sections],
  );

  useEffect(() => {
    if (isNavbarVerticalCollapsed) {
      HTMLClassList.add('navbar-vertical-collapsed');
    } else {
      HTMLClassList.remove('navbar-vertical-collapsed');
    }
    return () => {
      HTMLClassList.remove('navbar-vertical-collapsed-hover');
    };
  }, [isNavbarVerticalCollapsed, HTMLClassList]);

  // Control mouseEnter event
  let time = null;
  const handleMouseEnter = () => {
    if (isNavbarVerticalCollapsed) {
      time = setTimeout(() => {
        HTMLClassList.add('navbar-vertical-collapsed-hover');
      }, 100);
    }
  };
  const handleMouseLeave = () => {
    clearTimeout(time);
    HTMLClassList.remove('navbar-vertical-collapsed-hover');
  };

  return (
    <Navbar
      expand={navbarBreakPoint}
      className={classNames('navbar-vertical', {
        [`navbar-${navbarStyle}`]: navbarStyle !== 'transparent',
      })}
      variant="light"
    >
      <Flex alignItems="center">
        <ToggleButton />
        <Logo at="navbar-vertical" width={60} />
      </Flex>
      <Navbar.Collapse
        in={showBurgerMenu}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          backgroundImage:
            navbarStyle === 'vibrant'
              ? `linear-gradient(-45deg, rgba(0, 160, 255, 0.86), #0048a2),url(${bgNavbar})`
              : 'none',
        }}
      >
        <div className="navbar-vertical-content scrollbar">
          <Nav className="flex-column" as="ul">
            {/* {sections.map((section, idx) => ( */}
            {/*  // eslint-disable-next-line react/no-array-index-key */}
            {/*  // <Fragment key={`${idx}-${section.name}`}> */}
            {/*  //   <NavbarLabel label={capitalize(section.label)} /> */}
            {/*  //   {section.badge && ( */}
            {/*  //   <SoftBadge pill bg={section.badge.type} className="ms-2"> */}
            {/*  //     {section.badge.text} */}
            {/*  //   </SoftBadge> */}
            {/*  //   )} */}
            <NavbarVerticalMenu sections={sections} />
            {/*  // </Fragment> */}
            {/* // ))} */}
          </Nav>

          {navbarPosition === 'combo' && (
          <div className={`d-${topNavbarBreakpoint}-none`}>
            <div className="navbar-vertical-divider">
              <hr className="navbar-vertical-hr my-2" />
            </div>
            <Nav navbar>
              <NavbarTopDropDownMenus />
            </Nav>
          </div>
          )}
        </div>
      </Navbar.Collapse>
    </Navbar>
  );
}

NavbarVertical.propTypes = {
};

export default NavbarVertical;
